<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.000000pt"
    height="20.000000pt"
    viewBox="0 0 150.000000 150.000000"
    preserveAspectRatio="xMidYMid meet"
    :style="`margin-right: ${mr}`"
  >
    <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
      <path
        d="M326 1484 c-10 -27 -7 -274 4 -295 8 -15 22 -19 60 -19 l50 0 0 -98
           c0 -63 4 -102 12 -110 7 -7 36 -12 65 -12 l53 0 0 -91 0 -92 70 -97 70 -98 2
          -284 3 -283 35 0 35 0 3 284 2 284 70 98 70 98 0 90 0 91 49 0 c73 0 81 12 81
          126 l0 94 50 0 c38 0 52 4 60 19 13 26 13 266 0 292 -13 24 -65 26 -74 3 -3
          -9 -6 -65 -6 -125 l0 -109 -340 0 -340 0 0 109 c0 60 -3 116 -6 125 -4 10 -18
          16 -39 16 -21 0 -35 -6 -39 -16z m644 -384 l0 -70 -225 0 -225 0 0 70 0 70
          225 0 225 0 0 -70z m-120 -221 c0 -68 -2 -73 -47 -140 -27 -38 -50 -69 -53
          -69 -3 0 -26 31 -52 68 -47 65 -48 69 -48 139 l0 73 100 0 100 0 0 -71z"
      />
      <path
        d="M366 464 c-17 -17 -20 -33 -8 -50 11 -18 177 -104 199 -104 27 0 46
          24 38 49 -6 19 -178 121 -203 121 -6 0 -18 -7 -26 -16z"
      />
      <path
        d="M1007 432 c-106 -59 -111 -64 -103 -96 10 -39 45 -34 145 20 106 58
           119 74 85 108 -22 23 -29 21 -127 -32z"
      />
      <path
        d="M290 240 c-8 -14 -8 -26 0 -40 10 -19 19 -20 138 -18 124 3 127 4
          130 26 7 45 -11 52 -139 52 -108 0 -119 -2 -129 -20z"
      />
      <path
        d="M950 246 c-6 -8 -10 -25 -8 -38 3 -23 5 -23 133 -23 l130 0 3 29 c2
          16 -2 32 -10 37 -7 5 -63 9 -124 9 -85 0 -114 -3 -124 -14z"
      />
    </g>
  </svg>
</template>

<script>
const { defineComponent } = require('@nuxtjs/composition-api');

export default defineComponent({
  name: 'GravurIcon',
  props: {
    mr: {
      type: String,
      default: '20px',
    },
  },
});
</script>
